module.exports = __webpack_public_path__ + "img/logo-cytomine-coop.4a5cd544.png";